import { ContentLoading } from "@/components/content-loading"
import { SelectPayment as SelectIBANPayment } from "@/components/Top-up/SelectPayment"
import { cn } from "@/utils"
import { DepositType, PaymentSystem, useTopUpStore } from "@usher/pe-client-front-end-lib"
import { useCallback, useState } from "react"
import { PaymentSystemSelect } from "../../Payments/NewPayment/PaymentSystem"

export const SelectPayment = () => {
  const [loading, setLoading] = useState(false)
  const fiat = useTopUpStore((state) => state.fiat)
  const setFiat = useTopUpStore((state) => state.setFiat)
  const fetchOrderAmounts = useTopUpStore((state) => state.fetchOrderAmounts)
  const fetchPrices = useTopUpStore((state) => state.fetchPrices)
  const fetchAmounts = useCallback(async (system: PaymentSystem) => {
    setLoading(true)
    setFiat(system === PaymentSystem.SEPA ? "EUR" : "USD")
    await fetchOrderAmounts(DepositType.IBAN)
    await fetchPrices(void 0, DepositType.IBAN)
    setLoading(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <ContentLoading loading={loading}>
      <div className={cn("p-4", "bg-white mb-4 border")}>
        <div className="container max-w-[500px] flex flex-col items-center center">
          <span className="main-form-cards_title mb-0">Open Bank Account</span>
        </div>
        <div className="mt-4 bg-white border-t">
          <PaymentSystemSelect value={fiat === "EUR" ? PaymentSystem.SEPA : PaymentSystem.SWIFT} onChange={fetchAmounts} />
        </div>
      </div>
      <main className="p-4 bg-white border">
        <SelectIBANPayment depositType={DepositType.IBAN} isOrder />
      </main>
    </ContentLoading>
  )
}
